'use client';

import { isLoggedIn } from '@/utils/auth';
import { useSession } from 'next-auth/react';

type AuthUser = {
  /** 会員ID。未ログインは 0（コードベース共通の慣習に合わせる） */
  userId: number;
  email: string | null;
  isLoggedIn: boolean;
  isLoading: boolean;
};

/**
 * 認証ユーザー情報の単一アクセス点（GF-2384）。
 *
 * アプリ内では next-auth の useSession を直接呼ばず、この facade を通す。判定は isLoggedIn() に統一する。
 * 認証ライブラリを乗り換える際は、この hook と isLoggedIn、SessionProvider の配線だけを差し替えれば
 * 呼び出し側は無変更で済む。
 * ただし移行はカート周りから進めており、works / top / contact など一部の画面は
 * まだ useSession を直接呼んでいる。
 *
 * useSession はクライアント専用。サーバは lib/nextAuth の getSession を使う。
 */
export const useAuthUser = (): AuthUser => {
  const { data: session, status } = useSession();
  return {
    userId: session?.user?.id ?? 0,
    email: session?.user?.email ?? null,
    isLoggedIn: isLoggedIn(session),
    isLoading: status === 'loading',
  };
};
